export default {
    TaxPayerInfo: {
        Title: 'Thông tin người nộp thuế',
        InfoRegisGdt: 'Thông tin đăng ký thuế',
        InfoAdditional: 'Thông tin bổ sung',
        TaxCode: 'Mã số thuế/CCCD',
        CompanyName: 'Người nộp thuế',
        ContactName: 'Người đại diện pháp luật',
        Address: 'Địa chỉ',
        ProvinceName: 'Tỉnh/Thành phố',
        DistrictName: 'Quận/Huyện',
        WardName: 'Phường/Xã',
        ContactMobile: 'Điện thoại',
        ContactFax: 'Fax',
        ContactEmail: 'Email',
        FinanceStartDate: 'Ngày bắt đầu năm tài chính',
        TaxAgentName: 'Tên cơ quan thuế quản lý',
        ChapterCode: 'Mã chương',
        ChapterName: 'Tên chương',
        TooltipGetGipInfo: 'Thông tin đăng ký thuế được lấy từ </br> trang http://tracuunnt.gdt.gov.vn/',
        WarningGetGipInfo: 'Không có thông tin từ tổng cục thuế',
        CollectionAgencyCode: 'Mã cơ quan thu',
        TaxAgentCode: 'Mã cơ quan thuế quản lý',

    },
    nnt: {
        loaiDoiTuong: {
            DN: 'Doanh nghiệp',
            HKD: 'Hộ kinh doanh',
            CN: 'Cá nhân',
            required: 'Vui lòng chọn loại đối tượng NNT',
            helperText: 'Tự động điền từ thông tin mua hàng. Bạn có thể điều chỉnh nếu cần.'
        }
    },
    popup: {
        xacNhanLoaiDoiTuong: {
            title: 'Xác nhận loại đối tượng nộp thuế',
            body: 'Để đáp ứng yêu cầu mới từ Cơ quan thuế, vui lòng xác nhận loại đối tượng nộp thuế của bạn.',
            question: 'Bạn thuộc loại đối tượng nào?',
            optionHKD: 'Hộ kinh doanh (HKD)',
            optionCN: 'Cá nhân kinh doanh (CN)'
        }
    },
    PopupCQT: {
        Title: 'Thông tin chưa đầy đủ',
        Content: 'Tên cơ quan thuế quản lý của đơn vị đang bị trống. Thông tin này ảnh hưởng đến việc khai thuế, nộp thuế và các nghiệp vụ khác trên MISA mTax. Vui lòng cập nhật ngay để đảm bảo sử dụng phần mềm không bị gián đoạn.',
        BtnUpdate: 'Cập nhật ngay',
        BtnSkip: 'Để sau',
    },
}